import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import ptBR from './locales/pt-br.json'
import en from './locales/en.json'

const queryDetector = {
  name: 'queryDetector',
  lookup(): string | undefined {
    const params = new URLSearchParams(window.location.search)
    const lang = params.get('lang')
    if (lang === 'en') return 'en'
    if (lang === 'pt' || lang === 'pt-BR') return 'pt-BR'
    return undefined
  },
}

const domainDetector = {
  name: 'domainDetector',
  lookup(): string | undefined {
    const hostname = window.location.hostname
    if (hostname === 'bravicglobal.com' || hostname === 'www.bravicglobal.com') {
      return 'en'
    }
    return undefined
  },
}

const geoDetector = {
  name: 'geoDetector',
  lookup(): string | undefined {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (
      (tz && tz.startsWith('America/Sao_Paulo')) ||
      tz?.startsWith('America/Bahia') ||
      tz?.startsWith('America/Belem') ||
      tz?.startsWith('America/Fortaleza') ||
      tz?.startsWith('America/Recife') ||
      tz?.startsWith('America/Maceio') ||
      tz?.startsWith('America/Manaus') ||
      tz?.startsWith('America/Cuiaba') ||
      tz?.startsWith('America/Porto_Velho') ||
      tz?.startsWith('America/Campo_Grande') ||
      tz?.startsWith('America/Rio_Branco') ||
      tz?.startsWith('America/Araguaina') ||
      tz?.startsWith('America/Noronha') ||
      tz?.startsWith('America/Boa_Vista') ||
      tz?.startsWith('America/Santarem') ||
      tz?.startsWith('America/Eirunepe')
    ) {
      return 'pt-BR'
    }
    return 'en'
  },
}

const languageDetector = new LanguageDetector()
languageDetector.addDetector(queryDetector)
languageDetector.addDetector(domainDetector)
languageDetector.addDetector(geoDetector)

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'pt-BR': { translation: ptBR },
      en: { translation: en },
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['queryDetector', 'localStorage', 'domainDetector', 'geoDetector', 'navigator'],
      caches: ['localStorage'],
    },
  })

export default i18n
